import { getConfig } from './Config';

class ApiRequest
{
    constructor(options = {})
    {
        let token = null;
        let body  = {};

        if ('token' in options)
        {
            token = options.token;
        }

        if ('body' in options)
        {
            body = options.body;
        }

        this.token   = token;
        this.body    = body;
        this.headers = new Headers();
    };

    tokenHeaders = () =>
    {
        if (typeof this.token !== 'string')
        {
            throw new Error();
        }
        this.headers.append('Authorization', 'Bearer ' + this.token);
    };

    contentTypeHeaders = () =>
    {
        this.headers.append('Content-Type', 'application/json');
    };

    buildAuthRequest = () =>
    {
        this.contentTypeHeaders();
        let body = {  ...this.body, key: getConfig('API_KEY') };

        return new Request(getConfig('API_ROOT') + '/auth', {
            method: 'POST',
            mode  : 'cors',
            body  : JSON.stringify(body)
        });
    };

    buildPostRequest = (endpoint) =>
    {
        this.tokenHeaders();
        this.contentTypeHeaders();

        return new Request(getConfig('API_ROOT') + endpoint, {
            method: 'POST',
            mode  : 'cors',
            body  : JSON.stringify(this.body)
        });
    }

}

export default ApiRequest;



// WEBPACK FOOTER //
// ./src/classes/ApiRequest.js